export default __webpack_public_path__ + "static/media/eventDashboard_pm.7c0c665a.svg";